// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2CjVl","content":"styles_content__jDjWd","checkbox":"styles_checkbox__31YWD","checkboxLabel":"styles_checkboxLabel__2LHUb"};